module.exports = __webpack_public_path__ + "static/Gold-level-5ac050aa1881a42d8129b44e27a2093a.png";